import Icon from '@/components/snippets/icon/icon'

export function FilterCollapse({ label, children }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  return (
    <x-modal data-id={`filter-${id}`} className="group/filter dropdown-modal flex flex-col border-b border-neutral-light lg:w-full lg:px-margin">
      <button
        className="flex items-center justify-between gap-x-0.75 min-h-[56px] lg-max:px-margin py-1 text-left link-fade"
        data-modal-parent={`filter-${id}`}
        data-modal-role="toggle"
        aria-label={label}
      >
        <span className="text-xs font-ext font-bold uppercase">{label}</span>
        <div className="flex w-[13px] h-[7px] group-data-visible/filter:-rotate-180 transition-all children:size-full">
          <Icon id="chevron-down" />
        </div>
      </button>
      <div className="dropdown-content">
        <div className="flex flex-col gap-1.5 overflow-hidden">{children}</div>
      </div>
    </x-modal>
  )
}
